import { render, staticRenderFns } from "./QuestionTransportation.vue?vue&type=template&id=834a3f5a&scoped=true"
import script from "./QuestionTransportation.vue?vue&type=script&lang=js"
export * from "./QuestionTransportation.vue?vue&type=script&lang=js"
import style0 from "./QuestionTransportation.vue?vue&type=style&index=0&id=834a3f5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834a3f5a",
  null
  
)

export default component.exports